import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row gap-6 justify-between items-start md:items-center">
        <div>
          <div className="font-display font-bold text-base">
            WhatIs<span className="text-[color:var(--lime)]">Inside</span>
          </div>
          <p className="text-xs text-[color:var(--text-3)] mt-1 max-w-lg">
            AI-generated information for educational purposes only. Not medical, nutritional or professional advice —
            always check the product label and consult a professional.{" "}
            <Link to="/disclaimer" data-testid="footer-disclaimer-inline" className="text-[color:var(--lime)] hover:underline">
              Full disclaimer
            </Link>
            .
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs font-mono uppercase tracking-wider text-[color:var(--text-2)]">
          <Link to="/ingredients" data-testid="footer-ingredients" className="hover:text-[color:var(--lime)]">Ingredients</Link>
          <Link to="/categories" data-testid="footer-categories" className="hover:text-[color:var(--lime)]">Categories</Link>
          <Link to="/disclaimer" data-testid="footer-disclaimer" className="hover:text-[color:var(--lime)]">Disclaimer</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-[color:var(--lime)]">Terms</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[color:var(--lime)]">Privacy</Link>
          <Link to="/about" data-testid="footer-about" className="hover:text-[color:var(--lime)]">About</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
